module.exports = __webpack_public_path__ + "static/Logo-9b9a063457dfc9f2abf2087cd96b405e.png";